/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';

const ActionButtonsPause: React.FC<{
  id: string;
  isPaused: boolean;
  onSwitchClick: (id: string, isPaused: boolean) => void;
}> = ({ id, isPaused, onSwitchClick }) => {
  return (
    <Stack direction='row' spacing={1}>
      <IconButton
        aria-label='toggleoff'
        color={isPaused ? 'warning' : 'primary'}
        onClick={() => {
          onSwitchClick(id, !isPaused);
        }}>
        {isPaused && <ToggleOffIcon />}
        {!isPaused && <ToggleOnIcon />}
      </IconButton>
    </Stack>
  );
};

export default ActionButtonsPause;
